import { useMemo } from "react";
import { encode } from "uqr";
import { qrPath } from "../circles/circles";

/** `text` as a scannable QR code (dark on white, with a quiet zone). */
export function QrCode({ text, label, size = 192 }: { text: string; label: string; size?: number }) {
  const { path, modules } = useMemo(() => {
    const qr = encode(text, { ecc: "M", border: 2 });
    return { path: qrPath(qr.data), modules: qr.size };
  }, [text]);
  return (
    <svg
      className="qr-code"
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${modules} ${modules}`}
      shapeRendering="crispEdges"
    >
      <rect width={modules} height={modules} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
